import React from "react";
import "./SubmitDesign.scss";

interface SubmitDesignProps {
  closeModal: () => void;
  formType: "design" | "catalog" | "needs"; // Determine form type
}

const SubmitDesign: React.FC<SubmitDesignProps> = ({ closeModal, formType }) => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);

    // ✅ Convert to array for TypeScript compatibility
    console.log("FormData Entries:");
    Array.from(formData.entries()).forEach(([key, value]) => {
      console.log(key, value);
    });

    // ✅ Log Final Data as JSON-like Object
    console.log("Final Data Sent:", {
      form_type: formType,
      name: formData.get("name"),
      email: formData.get("email"),
      phone: formData.get("phone"),
      description: formData.get("description"),
      file: formData.get("file"),
    });

    fetch("form-handler.php", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.text())
      .then((data) => {
        console.log("Server Response:", data);
        alert(`Form submitted for ${formType}!`);
        closeModal();
        form.reset(); // ✅ Reset the form safely
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("Something went wrong. Please try again.");
      });
  };

  const heading =
    formType === "design"
      ? "Submit Your Design"
      : formType === "catalog"
      ? "Request for Catalog"
      : "Submit Your Design Ideas";

  return (
    <div className="modal-overlay" onClick={closeModal}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={closeModal}>×</button>
        <h2>{heading}</h2>
        <form className="design-form" onSubmit={handleSubmit} action="form-handler.php" method="POST">
          <input type="hidden" name="form_type" value={formType} />
          <input type="text" name="name" placeholder="Name" required />
          <input type="email" name="email" placeholder="Email" required />
          <input type="tel" name="phone" placeholder="Phone" required />
          
          {formType === "design" || formType === "needs" ? (
            <>
              <textarea name="description" placeholder="Describe your idea (optional)" rows={4}></textarea>
              <input type="file" name="file" accept="image/*,application/pdf" required />
            </>
          ) : null}

          <button type="submit">
            {formType === "catalog" ? "Request" : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SubmitDesign;
